import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  InterviewInvite: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  popup: {
    show: false,
    item: {}
  }
}

export const interviewInvitesSlice = createSlice({
  name: 'InterviewInvite',
  initialState: initialState,
  reducers: {
    setInterviewInvite: (state, { payload }) => {
      state.InterviewInvite = payload ?? payload;
    },
    setInterviewInvites: (state, { payload }) => {
      state.InterviewInvite = payload;
    },
    rejectInterviewInvites: (state, { payload }) => {
      state.error = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const acceptInterviewInvites = (token, payload, callback) => async (dispatch) => {
  let actualPayload = payload;
  let actualCallback = callback;
  if (typeof payload === 'function') {
    actualCallback = payload;
    actualPayload = {};
  }
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.acceptInterviewInvites(token, actualPayload)
    if (json.status >= 200 && json.status < 300) {
      actualCallback(true, json.data.message)
    } else {
      dispatch(setError(json.data))
      actualCallback(false, json.data.message || json.data.error || 'Failed to accept appointment invite.')
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const rejectInterviewInvites = (token, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.rejectInterviewInvites(token)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)

  }
  dispatch(setLoader(false))
}

export const fetchInterviewInvites = (token ,callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchInterviewInvites(token)
    
    if (result.status >= 200 && result.status < 300) {
        dispatch(setInterviewInvites(result.data.data));
        callback(true, result.data.message)
    }
    else {
      dispatch(setError(result.data))
      callback(false, result.data.message)
    }
  } catch (error) {
    console.log("error", error)
  }
  dispatch(setLoader(false))
}


export const { 
  setInterviewInvite, setInterviewInvites, setLoader, 
  setError

} = interviewInvitesSlice.actions


export default interviewInvitesSlice.reducer
export const interviewInvitesSelector = state => state.interviewInvites


